export default "assets/spinner-cb1296b7.svg";